import { computed, observable } from "mobx";
import * as Models from "../../../../../data/models";
import { TrackColors } from "../../../../../components";
import { OpenBetsBonusInfo } from "../../OpenBetsBonusInfo";

export class OpenPulseBetViewModel extends Models.BasicPulseBetViewModel {
    startTimeOfBet: number;

    @observable winningsData!: Models.WinningsDataModel;
    @observable finishedState?: { status?: { won?: { amount: string }, actions: { text: string, handler: () => void } } };
    @observable isFinished: boolean;

    public purchaseId: string;
    public gain: number;
    public animationStarted: number;
    public startAnimation: any;
    public progressInMilli: number;
    public pulseBetProgressData!: Models.PulseBetProgressData;
    public trackColor: TrackColors;
    // TODO: Yoni said that we probably do not need it, because we'll place the bet with the new odds anyway without prompting to the client
    hasOddsChangedHandler: (inProgressData: OpenPulseBetViewModel) => boolean;
    // TODO: The same as the PlaceBetHandler in the PulseBetMarketViewModel
    betAgainHandler: (inProgressData: OpenPulseBetViewModel) => void;
    backToBetPlacementHandler: (inProgressData: OpenPulseBetViewModel) => void;
    bonusInfo: OpenBetsBonusInfo;

    constructor(
        stake: number,
        gain: number,
        pulseBetMetadata: Models.PulseBetMarketAdditionalData,
        startTimeOfBet: number,
        currentGameProgress: number,
        purchaseId: string,
        hasOddsChangedHandler: (inProgressData: OpenPulseBetViewModel) => boolean,
        betAgainHandler: (inProgressData: OpenPulseBetViewModel) => void,
        backToBetPlacementHandler: (inProgressData: OpenPulseBetViewModel) => void,
        trackColor: TrackColors,
        bonusInfo: OpenBetsBonusInfo) {

        super(stake, pulseBetMetadata, currentGameProgress);

        this.trackColor = trackColor;
        this.gain = gain;
        this.startTimeOfBet = startTimeOfBet;
        this.purchaseId = purchaseId;
        this.isFinished = false;
        this.hasOddsChangedHandler = hasOddsChangedHandler;
        this.betAgainHandler = betAgainHandler;
        this.backToBetPlacementHandler = backToBetPlacementHandler;
        this.progressInMilli = 0;
        this.animationStarted = Date.now();
        this.bonusInfo = bonusInfo;
    }

    @computed get formatedGain(): string {
        return this.calculatedPeriodHelperDependency.formatWinnings(this.gain);
    }

    @computed get uniqueKey(): string {
        return `purchaseId:${this.purchaseId}market:${this.pulseBetMetadata.marketId}`;
    }

    @computed get periodFrames() {
        /* istanbul ignore next */
        let wrappedPeriods = this.calculatedPeriodHelperDependency.wrappedCalculatedPeriods(this.stake, this.pulseBetMetadata);
        return wrappedPeriods.map(p =>
            ({
                start: p.absoluteToGameFormattedGameStart,
                end: p.absoluteGameFormattedGameEnd
            }));
    }

    isBetExpired() {
        let duration = 0;

        for (let period of this.pulseBetProgressData.periods) {
            duration += period.duration;
        }

        duration *= 1000;

        return this.isFinished || this.pulseBetProgressData.expiredBetProgressInMilliseconds >= duration;
    }
}